// Package imports
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import { fetchSiteConfig } from "../../Store/Slices/DefsSlice";
import AccountCircle from "@mui/icons-material/AccountCircle";

// Custom imports
import { setNewCredentials } from "./Services";
import { validator } from "../../Js/Validator";
import LockIcon from "@mui/icons-material/Lock";
import Confirmation from "../../Components/Modal/Confirmation";
import LoginHeader from "../../Components/UI/LoginHeader";
import LoginFooter from "../../Components/UI/LoginFooter";
import { Typography } from "@mui/material";

// Component
const SetCredentials = () => {
  // Hooks
  const navigation = useNavigate();
  const { uid, paramusername } = useParams();
  const dispatch = useDispatch();

  // State
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [validate, setValidate] = useState(false);
  const [usernameError, setUsernameError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [repeatPasswordError, setRepeatPasswordError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Redux state
  const siteConfig = useSelector((state) => state.defs.siteConfig);

  // React logic hooks
  useEffect(() => {
    if (paramusername) {
      let onlyUsername = paramusername.split("@");
      onlyUsername.pop();
      setUsername(onlyUsername.join("@"));
    }
  }, []);

  // On blur get school name to display on top
  const getDefsFromAlias = () => {
    if (!password.includes("@")) {
      setPasswordError("Incorrect password");
      setValidate(false);
      setErrorMessage("");
      return false;
    }

    let alias = password.split("@");
    if (alias[alias.length - 1].trim().length == 0) {
      setPasswordError("Alias is missing!");
      setValidate(false);
      setErrorMessage("");
      return false;
    }

    dispatch(
      fetchSiteConfig({
        keyid: "site_config",
        keydata: {
          customer: {
            licenceAlias: alias[alias.length - 1].toUpperCase().trim(),
          },
        },
      })
    );
  };

  // Validate username on blur
  const usernameBlurValidate = () => {
    let validate = validator({ required: true, value: username });
    if (!validate["validate"]) {
      setUsernameError(validate["message"]);
      setErrorMessage("");
      setValidate(false);
    } else {
      setUsernameError(null);
      setErrorMessage("");
      setValidate(true);
      getDefsFromAlias();
    }
  };

  // Validate password on blur
  const passwordBlurValidate = () => {
    let validate = validator({ required: true, value: password });
    console.log("$$%%%%", validate);
    if (!validate["validate"]) {
      setPasswordError(validate["message"]);
      setErrorMessage("");
      setValidate(false);
    } else {
      setPasswordError(null);
      setErrorMessage("");
      setValidate(true);
    }
  };

  // Validate Repeat password on blur
  const passwordRepeatBlurValidate = () => {
    let validate = validator({ required: true, value: repeatPassword });
    if (!validate["validate"] || password.trim() !== repeatPassword.trim()) {
      setRepeatPasswordError(validate["message"]);
      setErrorMessage("");
      setValidate(false);
    } else {
      setRepeatPasswordError(null);
      setErrorMessage("");
      setValidate(true);
    }
  };

  // Validate credentials on login click & redirect to respective dashboard
  const validateCredentials = async () => {
    usernameBlurValidate();
    passwordBlurValidate();
    passwordRepeatBlurValidate();

    if (validate) {
      let response = await setNewCredentials(
        username + "@" + siteConfig.customer.licenceAlias,
        password,
        siteConfig.customer.customer_uuid,
        uid
      );
      console.log("%%%%%", response);
      if (response.status == 500) {
        setErrorMessage(response.message);
        setModalVisible(true);
      } else {
        setModalVisible(true);
        setErrorMessage("");
      }
    }
  };

  // Reset all states on successful login
  const resetState = () => {
    setUsername("");
    setPassword("");
    setRepeatPassword("");
    setUsernameError(null);
    setPasswordError(null);
    setRepeatPasswordError(null);
    setValidate(true);
    setErrorMessage("");
  };

  // JSX template
  return (
    <Grid
      container
      spacing={1}
      className="full-height"
      sx={{ alignItems: "center" }}
    >
      <Grid item sm={12} md={6}>
        <Box
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            display: { xs: "none", sm: "none", md: "block" },
          }}
        >
          <img
            src={require("../../assets/login.webp")}
            width="100%  "
            alt="Vocablab"
          ></img>
        </Box>
      </Grid>
      <Grid item sm={12} md={6}>
        <Box sx={{ p: 1, textAlign: "center" }}>
          <LoginHeader
            primaryText={
              !siteConfig || !siteConfig.schoolName
                ? "Your Institute"
                : siteConfig.schoolName
            }
            secondaryText="Set Credentials"
          ></LoginHeader>
          <Box>
            {/* {validateErrorMessage != null && (
              <Box sx={{ pt: 5, px: 10, textAlign: "center" }}>
                <Alert variant="filled" severity="error">
                  {validateErrorMessage}
                </Alert>
              </Box>
            )} */}
            <Box sx={{ pt: 5, px: 10, textAlign: "center" }}>
              {/* {defs["customer"] !== undefined && (
                <TextField
                  id="outlined-basic"
                  placeholder="Enter Username"
                  variant="outlined"
                  fullWidth
                  onBlur={() => {
                    usernameBlurValidate();
                  }}
                  onInput={(event) => {
                    setUsername(event.target.value);
                  }}
                  value={username}
                  InputProps={{
                    inputProps: { style: { padding: 10 } },
                    style: { borderRadius: 30 },
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle sx={{ color: "#D9D9D9" }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end" sx={{ color: "#D9D9D9" }}>
                        @{defs["customer"]["licenceAlias"]}
                      </InputAdornment>
                    ),
                  }}
                  helperText={usernameError}
                  error={usernameError != null}
                  onKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      validateCredentials();
                    }
                  }}
                  sx={{ borderRadius: 10 }}
                />
              )} */}
              <TextField
                id="outlined-basic"
                placeholder="Enter Username"
                variant="outlined"
                fullWidth
                onBlur={() => {
                  usernameBlurValidate();
                }}
                onInput={(event) => {
                  setUsername(event.target.value);
                }}
                InputProps={{
                  inputProps: { style: { padding: 10 } },
                  style: { borderRadius: 30 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle sx={{ color: "#D9D9D9" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={{ color: "#BBB" }}>
                        @{siteConfig.customer.licenceAlias}
                      </Typography>
                    </InputAdornment>
                  ),
                }}
                value={username}
                helperText={usernameError}
                error={usernameError != null}
                onKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    validateCredentials();
                  }
                }}
              />
            </Box>
            <Box sx={{ pt: 2, px: 10, textAlign: "left" }}>
              <TextField
                id="outlined-basic"
                placeholder="Enter Password"
                variant="outlined"
                fullWidth
                type="password"
                onInput={(event) => {
                  setPassword(event.target.value);
                }}
                value={password}
                onBlur={() => {
                  passwordBlurValidate();
                }}
                InputProps={{
                  inputProps: { style: { padding: 10 } },
                  style: { borderRadius: 30 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#D9D9D9" }} />
                    </InputAdornment>
                  ),
                }}
                helperText={passwordError}
                error={passwordError != null}
                onKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    validateCredentials();
                  }
                }}
              />
            </Box>
            <Box sx={{ pt: 2, px: 10, textAlign: "left" }}>
              <TextField
                id="outlined-basic"
                placeholder="Enter Repeat Password"
                variant="outlined"
                fullWidth
                type="password"
                onInput={(event) => {
                  setRepeatPassword(event.target.value);
                }}
                value={repeatPassword}
                onBlur={() => {
                  passwordRepeatBlurValidate();
                }}
                InputProps={{
                  inputProps: { style: { padding: 10 } },
                  style: { borderRadius: 30 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#D9D9D9" }} />
                    </InputAdornment>
                  ),
                }}
                helperText={repeatPasswordError}
                error={repeatPasswordError != null}
                onKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    validateCredentials();
                  }
                }}
              />
            </Box>
            <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
              <Button
                variant="contained"
                fullWidth
                onClick={validateCredentials}
                sx={{ borderRadius: 20, fontWeight: "600" }}
              >
                {" "}
                Save{" "}
              </Button>
            </Box>
            <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => {
                  navigation(-2);
                }}
                sx={{ borderRadius: 20, fontWeight: "600" }}
              >
                {" "}
                Login{" "}
              </Button>
            </Box>
            <LoginFooter></LoginFooter>
          </Box>
          <Confirmation
            visible={modalVisible}
            primaryText={
              errorMessage
                ? errorMessage
                : "Username and password changed successfully, Ready to Login"
            }
            image={errorMessage ? "error" : "thumb"}
            alert={true}
            toggleModal={(flag) => setModalVisible(flag)}
            timeout={2500}
            onClose={() => {
              navigation(-2);
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default SetCredentials;
